import { defaultParamsFilter, dataConfigTable, defaultDataModalTraceable, defaultDefaultTableTraceable, defaultTraceable } from "./state";

/**
 * Mutación para restablecer los datos iniciales del filtro.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDataFilter(state) {
    state.filter = defaultParamsFilter()
}

/**
 * Mutación manipular/alterar los datos del filtro.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataFilter(state, nextState) {
    state.filter = nextState
}

/**
 * Mutación manipular/alterar el estado de si los datos de la tabla están cargando o no.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setLoadingDataTable(state, nextState) {
    state.loadingDataTable = nextState
}

/**
 * Mutación manipular/alterar la información de la tabla de tanques.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTableConfig(state, nextState) {

    const { data, items } = nextState;

    state.tableConfig.data = data;
    if (items && typeof items === 'object') state.tableConfig.items = items;
}

/**
 * Mutación para resetear la información.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetTableConfig(state) {
    state.tableConfig = dataConfigTable()
}


/**
 * Mutación para establecer la paginación de los datos.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataPagination(state, { page, per_page }) {
    state.tableConfig.data.page = page
    state.tableConfig.data.per_page = per_page
}

/**
 * Mutación para resetear la información del modal de detalles de la trazabilidad de un producto.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDefaultDataModalTraceable(state) {
    state.dataModalTraceable = defaultDataModalTraceable()
}

/**
 * Mutación para establecer datos básicos de la información del modal de detalles de la trazabilidad de un producto.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataTraceable(state, { assignId, company_id, product_id, product }) {
    if (assignId) state.dataModalTraceable.assignId   = assignId
    if (company_id) state.dataModalTraceable.company_id = company_id
    if (product_id) state.dataModalTraceable.product_id = product_id
    if (product) state.dataModalTraceable.product = product
}

/**
 * Mutación para establecer la nueva información del modal de detalles de la trazabilidad de un producto.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataModalTraceable(state, nextState) {
    state.dataModalTraceable.traceableItems = nextState
}

/**
 * Mutación para establecer si esta cargar los datos de la tabla del detalles de trazabilidad.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTraceableLoading(state, nextState) {
    state.dataModalTraceable.loading = nextState
}

/**
 * Mutación para establecer la información de los datos de la tabla del detalles de trazabilidad.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTraceableData(state, nextState) {
    state.dataModalTraceable.table.data = nextState
}

/**
 * Mutación para restablecer la información de los datos de la tabla del detalles de trazabilidad.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetTableDataTraceableData(state) {
    state.dataModalTraceable.table = defaultDefaultTableTraceable()
}

/**
 * Mutación para establecer la paginación de los datos de la tabla del detalles de trazabilidad.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTraceablePagination(state, { page, per_page }) {
    state.dataModalTraceable.table.data.page = page
    state.dataModalTraceable.table.data.per_page = parseInt(per_page)
}

/**
 * Mutación para alterar la información de la data: actionToTraceablePQ.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setActionToTraceablePQ(state, nextState) {
    state.actionToTraceablePQ = nextState
}

/**
 * Mutación para alterar la información del traceable.
 *
 * @param {*} state
 * @param {*} nextState
 */
export function setTraceable(state, nextState) {
    state.traceable = nextState
}

/**
 * Mutación para restablecer filtros para el componente de visualizacion de comentarios
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetTableFilter(state) {
    state.filter_table = defaultParamsFilter()
}

/**
 * Mutación manipular/alterar los filtros para el componente de visualizacion de comentarios
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTableFilter(state, nextState) {
    state.filter_table = nextState
}

/**
 * Mutación ocultar el formulario de comentarios
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function hideForm(state) {
    state.filter_table.show_form = false
}

/**
 * Mutación para reiniciar el traceable.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function resetTraceable(state) {
    state.traceable = defaultTraceable()
}
